<template>
  <Popup
    :visible="visible"
    position="bottom"
    :overlay="false"
    :class="classes(
      n(),
    )
    "
  >
    <div
      :class="classes(n('--container'))"
      @touchstart="handleContainerClick"
      @click="handleContainerClick"
    >
      <div
        v-if="closeBtnText"
        :class="classes(n('--header'))"
      >
        <span
          :class="classes(n('--header--close-btn'))"
          @click="emit('close')"
        >{{ closeBtnText }}</span>
      </div>
      <DefaultKeyboard
        v-if="type === 'default'"
        v-bind="$props"
        @click="handleKeyboardClick"
      />
      <ConfirmKeyboard
        v-else
        v-bind="$props"
        @click="handleKeyboardClick"
      />
    </div>
  </Popup>
</template>

<script lang="ts">
import { defineComponent, onMounted } from 'virtual-vue';
import { props } from './props';
import { emits, KeyboardEmitsEvent } from './emits';
import { createNamespace } from '../utils/components';
import Popup from '../popup/popup.vue';
import DefaultKeyboard from './components/keyboard-default.vue';
import ConfirmKeyboard from './components/keyboard-confirm.vue';
import { useKeyboardEvents } from './hooks';

const { name, n, classes } = createNamespace('keyboard');

export default defineComponent({
  name,
  components: { Popup, DefaultKeyboard, ConfirmKeyboard },
  props,
  emits,
  setup(props, { emit }) {
    const { handleContainerClick, initEvents } = useKeyboardEvents(props, emit);
    // 处理键盘点击
    const handleKeyboardClick = (options: { type: KeyboardEmitsEvent, value?: string }) => {
      const { type, value } = options;
      type === 'input' ? emit('input', value) : emit(type);
    };

    onMounted(() => {
      initEvents();
    });

    return {
      n,
      classes,
      emit,
      handleContainerClick,
      handleKeyboardClick,
    };
  },
});
</script>
